/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  /**
  * Slider Skip
  */
  (function initSliderSkipContent() {
    const skipButtons = document.querySelectorAll('.skip-link--section');

    skipButtons.forEach((button, index) => {
      // 1. Find the parent shopify-section
      const currentSection = button.closest('.shopify-section');

      if (currentSection) {
        // 2. Find the next sibling section
        const nextSection = currentSection.nextElementSibling;

        if (nextSection) {
          // 3. Assign the href to point to that ID
          button.setAttribute('href', `#${nextSection.id}`);
        }
      }
    });
  }());


  /**
  * Flickity Pause Button
  */
  function initSliderPause() {
    let sliders = document.querySelectorAll('slideshow-component');

    sliders.forEach(function (sliderEl) {
      let flkty = window.theme.Flickity.data(sliderEl);

      if (!flkty) return;

      let button = sliderEl.querySelector('.js-pause-slider');
      if (!button) return;

      let pauseEl  = button.querySelector('.pause-container');
      let resumeEl = button.querySelector('.resume-container');

      let isPaused = false;

      button.addEventListener('click', function () {
        if (!isPaused) {
          flkty.stopPlayer();

          pauseEl.classList.remove('is-visible');
          resumeEl.classList.add('is-visible');

        } else {
          flkty.playPlayer();

          pauseEl.classList.add('is-visible');
          resumeEl.classList.remove('is-visible');
        }

        isPaused = !isPaused;
      });
    });
  }


    // Add custom code below this line
  document.addEventListener('DOMContentLoaded', (event) => {
    initSliderPause();
  });


  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your letiables into the global scope.
})();
